import { IServicePeriod } from '../../../../redux/reducers';
import { IServicePeriodSchema } from '../../../../repositories/billing-tariffs/v1/publish-terms';
import { getPeriodId } from './getPeriodId';

export function mapPeriod(period: IServicePeriodSchema): IServicePeriod {
  const periodId = getPeriodId(period);

  return {
    ...period,
    id: periodId,
    price: parseFloat(period.price),
    marketingPrice: parseFloat(period.marketingPrice),
    token: period.token || null,
  };
}
